// 代理管理api

import {baseRequest} from './base'

/**
 * @desc 查询代理商列表
 */
function getAgencyList(params){
  //清除空白字段
  params = utils.common.checkNull(params);
  let tempUrl = '/api/pcWeb/teaAgent/'
  return baseRequest(tempUrl,'get',params);
}

/**
 * @desc 根据代理ID获取代理信息
 */
function getAgencyById(id){
  return baseRequest(`/api/pcWeb/teaAgent/${id}`,'get');
}

/**
 * @desc 新增代理
 */
function addAgency(params){
  return baseRequest(`/api/pcWeb/teaAgent/create`,'post',params);
}

/**
 * @desc 删除代理
 */
function deleteAgency(id){
  return baseRequest(`/api/pcWeb/teaAgent/delete/${id}`,'get');
}

/**
 * @desc 修改代理
 */
function updateAgency(id,params){
  //清除空白字段
  params = utils.common.checkNull(params);
  return baseRequest(`/api/pcWeb/teaAgent/update/${id}`,'post',params);
}

/**
 * @desc 查询代理商列表-没有被关联的代理
 */
function listAgentOfNoBinding(params){
  //清除空白字段
  params = utils.common.checkNull(params);
  let tempUrl = '/api/pcWeb/teaAgent/listAgentOfNoBinding'
  return baseRequest(tempUrl,'get',params);
}



export default {
  getAgencyList: getAgencyList,
  getAgencyById: getAgencyById,
  addAgency: addAgency,
  deleteAgency: deleteAgency,
  updateAgency: updateAgency,
  listAgentOfNoBinding: listAgentOfNoBinding,
}